{
  "dismiss": "Odbaci"
}
